/**
 * Anhang-Grenzen für Tickets — geteilt zwischen `MeldeDialog` (neues Ticket)
 * und `TicketDetail` (Kommentar/Ergänzung): höchstens `MAX_ANHAENGE` Anhänge
 * je Eintrag, jede Datei höchstens `MAX_ANHANG_BYTES` groß. Zu große Dateien
 * werden übersprungen, der Rest bis zur Höchstzahl trotzdem übernommen
 * (Teil-Annahme statt ganzen Batch verwerfen).
 */
export const MAX_ANHAENGE = 10;
export const MAX_ANHANG_BYTES = 20 * 1024 * 1024;

export type AnhangPruefErgebnis = {
  /** Indizes in `neu`, die übernommen werden dürfen, in ursprünglicher Reihenfolge. */
  uebernehmen: number[];
  /** Deutsche Fehlermeldung für Übersprungenes, oder `null` wenn alles passt. */
  meldung: string | null;
};

export function pruefeAnhaenge(vorhanden: number, neu: { name: string; size: number }[]): AnhangPruefErgebnis {
  const zuGross: number[] = [];
  const passend: number[] = [];
  neu.forEach((a, i) => (a.size > MAX_ANHANG_BYTES ? zuGross.push(i) : passend.push(i)));

  const platz = Math.max(0, MAX_ANHAENGE - vorhanden);
  const uebernehmen = passend.slice(0, platz);
  const abgelehntWegenLimit = passend.length - uebernehmen.length;

  const meldungen: string[] = [];
  if (zuGross.length === 1) {
    meldungen.push(`„${neu[zuGross[0]].name}“ ist größer als 20 MB und wurde nicht angehängt.`);
  } else if (zuGross.length > 1) {
    meldungen.push(`${zuGross.length} Dateien sind größer als 20 MB und wurden nicht angehängt.`);
  }
  if (abgelehntWegenLimit === 1) {
    meldungen.push(`Höchstens ${MAX_ANHAENGE} Anhänge — 1 Datei wurde nicht angehängt.`);
  } else if (abgelehntWegenLimit > 1) {
    meldungen.push(`Höchstens ${MAX_ANHAENGE} Anhänge — ${abgelehntWegenLimit} Dateien wurden nicht angehängt.`);
  }

  return { uebernehmen, meldung: meldungen.length ? meldungen.join(" ") : null };
}
